import voucherPopupArray from '../vouchers/voucherPopupArray'
import { getDocumentKind } from '../../components/editors/documents.utils'

/**
 * The user-visible title of a document: a check reads "שיק <id>", a voucher reads
 * its path label (or a generic "שובר" before it has been scanned) plus the id, a
 * not-yet-loaded document reads the generic "מסמך", and anything else reads
 * "מסמך ריק". Keyed off the document kind so it holds for cards whose concrete
 * type isn't set yet. Shared so the document page heading, the editor headings,
 * the entry cards, and the journal's document link stay in step.
 */
export default function documentTitle(document) {
    if (!document) {
        return 'מסמך'
    }

    const kind = getDocumentKind(document)

    if (kind === 'payment') {
        return `שיק ${document.id}`
    }

    if (kind === 'voucher') {
        const voucher = document.voucher42 ?? document.voucher38 ?? document.voucher27 ?? null
        const label = voucher != null ? voucherPopupArray(voucher).voucherType : 'שובר'
        return `${label} ${document.id}`
    }

    return 'מסמך ריק'
}
